/**
 * Clears all Flare-related user data from browser storage.
 * Call this function when signing out to prevent stale data
 * from appearing for a new user.
 */
export function clearUserData() {
  if (typeof window === "undefined") {
    return;
  }

  try {
    // Clear sessionStorage items
    window.sessionStorage.removeItem("flare:sessionUploadedVideos");

    // Clear localStorage items
    window.localStorage.removeItem("flare:libraryProjectId");
    window.localStorage.removeItem("flare:thumbnailVersions");
  } catch (error) {
    console.error("Error clearing user data:", error);
  }
}

export default clearUserData;

